import Vue from 'vue'
import App from './App.vue'
import router from './router/index.js'

import './assets/css/public.css'
import './assets/icon/iconfont.css';

import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)

Vue.config.productionTip = false;

// 忽略标签 针对开放表情
// Vue.config.ignoredElements = 
// [
//   'wx-open-subscribe',
// ]

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  next()
})

 
new Vue({
  router,
  data(){
    return{
		// API: 'http://8.148.200.210:3389/api/v0/',			// 测试 地址
		// API: 'https://www.humall2026.sy/api/v0/',  //本地 地址
		API: 'https://www.humall2026.cn/api/v0/',  //生产 地址
    }
  },
  render: h => h(App),
}).$mount('#app')

